import { Spin } from 'antd'
import React from 'react'

function PadContainer({ children, className, title, loading }) {
  return (
    <Spin spinning={loading}>
      <div className={`w-full px-2 py-5 md:px-10 ${className}`}>
        <p className='text-lg font-semibold text-blue'>{title}</p>
        {children}
      </div>
    </Spin>
  )
}

export default PadContainer
PadContainer.defaultProps = {
  loading: false
}